export const normalizeStatusList = (payload) => {
  if (payload?.size) {
    return { status: payload.toArray() };
  }
  return undefined;
};

export const automatedJobQueryParams = ({
  jobsTeamSharingFeatureEnabled,
  organizationId,
  ownership = {},
  statusList,
  username,
  user,
  defaultParams = {},
  ...rest
}) => {
  const userId = user?.getUserID() || username;

  if (jobsTeamSharingFeatureEnabled) {
    if (ownership.type === 'team') {
      return {
        ...defaultParams,
        team_id: ownership.name,
        org_id: organizationId,
        ...normalizeStatusList(statusList),
        ...rest,
      };
    }

    if (ownership.type === 'organization') {
      return {
        ...defaultParams,
        org_id: organizationId,
        ...normalizeStatusList(statusList),
        ...rest,
      };
    }

    if (ownership.type === 'user') {
      return {
        ...defaultParams,
        org_id: organizationId,
        owner: ownership.name || username,
        user_id: ownership.id || user?.get('user_id'),
        ...normalizeStatusList(statusList),
        ...rest,
      };
    }

    return {
      ...defaultParams,
      owner: ownership.name || username,
      ...normalizeStatusList(statusList),
      ...rest,
    };
  }

  if (ownership.type === 'organization') {
    return {
      username,
      owner_type: ownership.type,
      ...normalizeStatusList(statusList),
      subaccounts: false,
      ...rest,
    };
  }

  return {
    userId,
    org_id: organizationId,
    owner: ownership.name || username,
    user_id: ownership.id || user?.get('user_id'),
    owner_type: 'user',
    subaccounts: false,
    ...normalizeStatusList(statusList),
    ...rest,
  };
};
